import React from 'react';
import { hashHistory } from 'react-router';
import Grid from "@material-ui/core/Grid";
import TableInc from '../../../../../shared-ui/TableInc';
import ButtonInc from '../../../../../shared-ui/ButtonInc';
import { formatDateLocale } from '../../../../../lib/utils.es6';
import { TablePagination } from '@mui/material';

export function DisplayClaims({ currencyCode, classes, claims, pagingData, getClaimsFiltered }) {
  const safeClaimsData = claims || [];
  const safePagingData = pagingData || { total: 0, page: 1, size: 10 };

  const claimsFormatted = safeClaimsData.map(function(claim) {
    return {
      ...claim,
      policy_number: claim.claim_details ? claim.claim_details.policy_number : 'N/A',
    };
  });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={12} sm={12}>
        <TableInc
          columns={[
            {
              title: 'Claim Number',
              field: 'claim_number',
              render: function(rowData) { return rowData.claim_number || 'N/A'; }
            },
            {
              title: 'Policy Number',
              field: 'policy_number',
            },
            {
              title: 'Status',
              field: 'status',
              render: function(rowData) { return rowData.status || 'N/A'; }
            },
            {
              title: 'Payable Amount',
              field: 'benefit_usages',
              render: function(rowData) {
                if (!rowData.benefit_usages || rowData.benefit_usages.length === 0) return 'N/A';
                var total = rowData.benefit_usages.reduce(function(sum, b) {
                  return sum + b.benefit_amount_in_cents;
                }, 0);
                // Use the claim's own currency; fall back to partner country currency.
                var claimCurrency = rowData.currency || currencyCode;
                return claimCurrency + ' ' + (total / 100).toLocaleString();
              }
            },
            {
              title: 'Created At',
              field: 'created_at',
              render: function(rowData) { return formatDateLocale(rowData.created_at) || 'N/A'; }
            },
            {
              title: 'Created By',
              field: 'web_agent_name',
            },
            {
              title: 'Action',
              field: 'claimaction',
              render: function(rowData) {
                return (
                  <div className={classes.claimactionbt}>
                    <ButtonInc
                      onClick={function() {
                        hashHistory.push('admin/claim-processing-v2/' + rowData.guid);
                      }}
                      variant="contained"
                    >
                      View Claim
                    </ButtonInc>
                  </div>
                );
              }
            },
          ]}
          data={claimsFormatted}
          options={{
            showTitle: false,
            pageSize: safePagingData.size || 10,
            paging: false,
            search: false,
          }}
          components={{
            Pagination: function() { return null; }
          }}
        />
        <TablePagination
          component="div"
          count={safePagingData.total || 0}
          page={(safePagingData.page || 1) - 1}
          rowsPerPage={safePagingData.size || 10}
          rowsPerPageOptions={[5, 10, 20, 50, 100]}
          onPageChange={function(event, newPage) {
            getClaimsFiltered({ page: newPage + 1, size: safePagingData.size });
          }}
          onRowsPerPageChange={function(event) {
            var newSize = parseInt(event.target.value, 10);
            getClaimsFiltered({ page: 1, size: newSize });
          }}
        />
      </Grid>
    </Grid>
  );
}
